import React from "react";
import { Box } from "@mui/material";

const Customers = () => {
  return <Box>Customers</Box>;
};

export default Customers;
